/**
 * QRMaps Design System - Breakpoint Tokens
 *
 * Responsive design breakpoints
 * Current mobile breakpoint is 768px (from MainMap.js)
 */

export const breakpoints = {
  xs: '0px',
  sm: '576px',
  md: '768px',   // Current mobile breakpoint used throughout the app
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

// Pixel values (for JavaScript usage)
export const breakpointValues = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

// Media query helpers (for styled-components)
export const mediaQueries = {
  // Mobile-first approach
  mobile: `@media (max-width: ${breakpoints.md})`,
  tablet: `@media (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg})`,
  desktop: `@media (min-width: ${breakpoints.lg})`,
  wide: `@media (min-width: ${breakpoints.xl})`,

  // Specific breakpoints
  xs: `@media (min-width: ${breakpoints.xs})`,
  sm: `@media (min-width: ${breakpoints.sm})`,
  md: `@media (min-width: ${breakpoints.md})`,
  lg: `@media (min-width: ${breakpoints.lg})`,
  xl: `@media (min-width: ${breakpoints.xl})`,
  xxl: `@media (min-width: ${breakpoints.xxl})`,

  // Max-width queries (for mobile-specific styles)
  maxXs: `@media (max-width: ${breakpoints.xs})`,
  maxSm: `@media (max-width: ${breakpoints.sm})`,
  maxMd: `@media (max-width: ${breakpoints.md})`,
  maxLg: `@media (max-width: ${breakpoints.lg})`,
  maxXl: `@media (max-width: ${breakpoints.xl})`,
};

// Helper function to check if current viewport matches breakpoint
export const isMobileViewport = () => {
  return typeof window !== 'undefined' && window.innerWidth <= breakpointValues.md;
};